import { Injectable } from '@angular/core';

export interface AppConfig {
  apiBaseUrl: string;
  keycloak: {
    url: string;
    realm: string;
    clientId: string;
  };
  environment: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config!: AppConfig;
  private loadPromise?: Promise<void>;

  load(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = fetch('/assets/config.json')
        .then(response => response.json())
        .then(config => { this.config = config; });
    }
    return this.loadPromise;
  }

  get apiBaseUrl(): string {
    return this.config.apiBaseUrl;
  }

  get keycloak(): AppConfig['keycloak'] {
    return this.config.keycloak;
  }

  get environment(): string {
    return this.config.environment;
  }
}
